import React from 'react';
import TopB from './Lp/pattern-b/TopB';
import { useScrollToTop } from '../hooks/useScrollToTop';

const Top = () => {
  useScrollToTop();
  return <TopB />;
};

export default Top;
